import enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetAutoCompleteProductTemplates(searchText, productType) {
    let _input = {
      language: i18n.locale,
      searchText: searchText,
      productType: productType,
    };

    return API.peakRealTimeAPI
      .post("/api/Product/GetAutoCompleteProductTemplates", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplatesByProductIdList(productIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productIdList: productIdList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplatesByProductIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplatesByProductCodeList(productCodeList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productCodeList: productCodeList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplatesByProductCodeList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateProductTemplateOnce(productTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplate: productTemplate.insertProductTemplate,
      skuGroupModelList: productTemplate.skuGroupModelList,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/CreateProductTemplateOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestProductCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSuggestProductCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUnitList(unitType, isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unitType: unitType,
      isDeleted: false,
      isUseMainDatabase: isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Product/GetUnitList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateUnitOnce(unit) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unit: unit,
    };

    return API.peakRealTimeAPI.post("/api/Product/CreateUnitOnce", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateUnit(unit) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unit: unit,
    };
    return API.peakRealTimeAPI.post("/api/Product/EditUnit", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoVoidUnit(unitIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unitIdList: unitIdList,
    };
    return API.peakRealTimeAPI.post("/api/Product/VoidUnit", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSuggestUnitCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSuggestUnitCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateById(input) {
    let _input = {
      productTemplateId: input,
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetProductTemplateById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateFavoriteProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productId: input.productId,
      favoriteTypeId: input.favoriteTypeId,
    };
    return API.peakAPI.post("/api/Product/UpdateFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteFavoriteProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productId: input.productId,
      financeTypeId: input.financeTypeId,
    };
    return API.peakAPI.post("/api/Product/DeleteFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTransactionNumberByLotDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Product/GetTransactionNumberByLotDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFavoriteProduct(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: financeTypeId,
    };
    return API.peakAPI.post("/api/Product/GetFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductTemplateOnce(productTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplate: productTemplate.insertProductTemplate,
      updateSkuGroupModelList: productTemplate.skuGroupModelList,
      isUpdateRecordJournalCostOfGoodsSold:
        productTemplate.insertProductTemplate.type === enums.ProductTemplateType.Product,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/UpdateProductTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoImportProductTemplate(productTemplateList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateList: productTemplateList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Product/CreateProductTemplateMultiple", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailChartBySell(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailChartBySell", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailChartByPurchase(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailChartByPurchase", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailCostGraphSummary(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      year: input.year,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailCostGraphSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateIdMonitoringList(type) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      type: type,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductTemplateIdMonitoringList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateMonitoringSummary(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductTemplateMonitoringSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetProductTemplateIdMonitoring(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      type: input.type,
      productTemplateIdList: input.productTemplateIdList,
    };
    return API.peakAPI
      .post("/api/DashBoard/SetProductTemplateIdMonitoring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockPurchasePriceChangeChartModel(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      stockPriceChangeChartOptionType: input.stockPriceChangeChartOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetStockPurchasePriceChangeChartModel", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockSellPriceChangeChart(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      stockPriceChangeChartOptionType: input.stockPriceChangeChartOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetStockSellPriceChangeChart", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidProductTemplate(productTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/VoidProductTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoUpdateProductTemplateIsArchived(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: input.productTemplateIdList,
      isArchived: input.isArchived,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/UpdateProductTemplateIsArchived", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockChangeFromDate(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: input.date,
    };

    return API.peakRealTimeAPI
      .post("/api/Product/GetStockChangeFromDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAdjustProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: input.date,
      amount: input.amount,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Product/DoAdjustProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductTemplateForRecalculateCostofGoodsSold(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post(
        "/api/Product/UpdateProductTemplateForRecalculateCostofGoodsSoldByProductTemplateId",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoAddProductPrice(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
      price: input.amount,
      discountType: input.discountType,
      discount: input.discount,
    };
    return API.peakRealTimeAPI.post("/api/Product/AddProductPrice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductPrice(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
      oldName: input.oldName,
      price: input.amount,
      discountType: input.discountType,
      discount: input.discount,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/UpdateProductPrice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteProductPrice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/DeleteProductPrice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductPriceList(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetProductPriceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidAdjustProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      stockActivityId: input.stockActivityId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/DoVoidAdjustProduct", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetProductRemainStock(productTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakAPI.post("/api/Product/GetProductRemainStock", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetStockActivityForSearchLotByTransaction(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      productTemplateId: input.productTemplateId,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakAPI
      .get("/api/Product/GetStockActivityForSearchLotByTransaction", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetStockActivityDetailList(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      stockActivityIdList: input.stockActivityIdList,
    };
    return API.peakAPI
      .post("/api/Product/GetStockActivityDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetProductBeginningBalanceList(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetProductBeginningBalanceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  UpdateProductBeginningBalance(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      beginningBalanceList: input.beginningBalanceList,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/UpdateProductBeginningBalance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateProductTemplateIssuedDocument(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/ValidateProductTemplateIssuedDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecentlyPriceProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      contactId: input.contactId,
    };
    return API.peakAPI.post("/api/Product/GetRecentlyPriceProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSkuGroupByProductTemplateId(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSkuGroupByProductTemplateId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTotalQueue(input) {
    return API.peakRealTimeAPI
      .post("/api/Product/GetTotalQueue", input.productTemplateId, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUploadProductImageOne(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      file: input.file,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/UploadProductImageOne", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
